import { createSelector } from 'reselect'

const to = state => state.redirect.to
const redirect = state => state.redirect.redirect

export {
  to,
  redirect
}
